var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductcleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.163,
    height: 24,
    viewBox: "0 0 24.163 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "product_cleaning",
    "data-name": "product cleaning",
    transform: "translate(0 -0.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M24.062,12.131A8.933,8.933,0,0,0,19.25,4.812c-.1,0-.1-.1-.2-.1v-.8a3.874,3.874,0,0,0-1.1-2.707,3.905,3.905,0,0,0-5.414-.1,3.712,3.712,0,0,0-1.2,2.206H7.319a.431.431,0,0,0-.4.4.431.431,0,0,0,.4.4H11.63a1.341,1.341,0,0,1,1.4,1.2,1.327,1.327,0,0,1-1.3,1.3h-1.3a1.2,1.2,0,0,0-1.5,1.2v1H6.717v-1a1.486,1.486,0,0,0-1.6-1.4H2.607a.459.459,0,0,1-.5-.4v-1.7a.459.459,0,0,1,.5-.4H6.016a.431.431,0,0,0,.4-.4.431.431,0,0,0-.4-.4H2.607a1.057,1.057,0,0,0-1,.6l-.5.2A1.3,1.3,0,0,0,0,5.213a1.388,1.388,0,0,0,1.1,1.3l.5.1a1.234,1.234,0,0,0,1,.5H5.113a.81.81,0,0,1,.9.7v1h-.6a2.248,2.248,0,0,0-2.206,2.306v.7a2.556,2.556,0,0,0-1.2.8,7.929,7.929,0,0,0,0,10.427,2.822,2.822,0,0,0,2.105,1H21.656a2.462,2.462,0,0,0,2.506-2.406c-.1-10.026-.1-9.424-.1-9.525ZM.7,5.213a.561.561,0,0,1,.5-.6h.2v1.3H1.2c-.3-.2-.5-.4-.5-.7Zm11.43-2.005A3.12,3.12,0,0,1,15.239.7,3.167,3.167,0,0,1,18.448,3.91v.7H13.736a2.245,2.245,0,0,0-1.6-1.4ZM3.91,11.129a1.565,1.565,0,0,1,1.5-1.6h4.712a1.565,1.565,0,0,1,1.5,1.6v.6H3.81l.1-.6Zm-1.4,11.53a7.186,7.186,0,0,1,0-9.525,2,2,0,0,1,1.6-.7H11.53a2.366,2.366,0,0,1,1.6.7,7.186,7.186,0,0,1,0,9.525,2,2,0,0,1-1.6.7H4.111a2.366,2.366,0,0,1-1.6-.7Zm20.854-1a1.779,1.779,0,0,1-1.8,1.7H13.335a4.876,4.876,0,0,0,1.1-1.4H19.45a2.482,2.482,0,0,0,2.506-2.506v-1.1a2.482,2.482,0,0,0-2.506-2.506H16.643a.4.4,0,1,0,0,.8H19.45a1.8,1.8,0,0,1,1.8,1.8v1.1a1.8,1.8,0,0,1-1.8,1.8H14.838a8.005,8.005,0,0,0-1.2-8.622,2.556,2.556,0,0,0-1.2-.8v-.7a2.248,2.248,0,0,0-2.206-2.306h-.6v-1a.884.884,0,0,1,.9-.8h1.3a2.051,2.051,0,0,0,2.005-1.8h4.411a1.889,1.889,0,0,1,.8.2,7.918,7.918,0,0,1,4.411,6.717C23.361,12.532,23.361,10.728,23.361,21.656Z",
    fill: "#7d90a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000158748234693391836890000002174493422636295093_",
    d: "M18.6,6.9a2.342,2.342,0,0,0-3.4,2.2,4.925,4.925,0,0,0,2.9,4.5,2.342,2.342,0,0,0,3.4-2.2A4.925,4.925,0,0,0,18.6,6.9Zm2.2,4.5A1.636,1.636,0,0,1,18.4,13a4.273,4.273,0,0,1-2.5-3.8,1.636,1.636,0,0,1,2.4-1.6,4.108,4.108,0,0,1,2.5,3.8Z",
    transform: "translate(0.063 0.025)",
    fill: "#7d90a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.2,3.2a.43.43,0,0,0,.4-.4V2.5a.4.4,0,1,0-.8,0v.4A.446.446,0,0,0,15.2,3.2Z",
    transform: "translate(0.04)",
    fill: "#7d90a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000078742426415969885660000011585550658850766511_",
    d: "M16.6,3.2a.43.43,0,0,0,.4-.4V2.5a.4.4,0,1,0-.8,0v.4A.446.446,0,0,0,16.6,3.2Z",
    transform: "translate(0.043)",
    fill: "#7d90a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000018229643454943908400000007775937707603038394_",
    d: "M13.8,3.2a.43.43,0,0,0,.4-.4V2.5a.4.4,0,1,0-.8,0v.4A.446.446,0,0,0,13.8,3.2Z",
    transform: "translate(0.036)",
    fill: "#7d90a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000085943895207958590000000010082814074298321058_",
    d: "M11.2,21.9a.908.908,0,0,0,.7-.3,4.852,4.852,0,0,0,1.5-3.5,6.47,6.47,0,0,0-1.6-4,1.136,1.136,0,0,0-.8-.3H4.5a1.136,1.136,0,0,0-.8.3,6.143,6.143,0,0,0-1.6,4,4.852,4.852,0,0,0,1.5,3.5.908.908,0,0,0,.7.3ZM2.8,18.1a5.535,5.535,0,0,1,1.5-3.6c.1-.1.1-.1.2-.1H11c.1,0,.2,0,.2.1a6.1,6.1,0,0,1,1.5,3.6,4.529,4.529,0,0,1-1.3,3c-.1.1-.1.1-.2.1H4.3c-.1,0-.2,0-.2-.1A4.335,4.335,0,0,1,2.8,18.1Z",
    transform: "translate(0 0.063)",
    fill: "#7d90a4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductcleaning);
export default __webpack_public_path__ + "static/media/product cleaning.852adcbece4ea0c9436a0d5416f7bafa.svg";
export { ForwardRef as ReactComponent };